module.exports = __webpack_public_path__ + "img/46.e9ac968c.gif";